import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddParametreModal",
  tabindex: "-1",
  role: "dialog",
  ref: "addParametreModalRef",
  "aria-labelledby": "tooltipmodal",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "Parametre"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12 mb-3" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-12 mb-3" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "dz-message needsclick" }
const _hoisted_15 = {
  key: 0,
  class: "default-image-container"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "dropzone-previews"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  class: "btn btn-primary",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            class: "btn-close py-0",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "parametreForm",
            onSubmit: _ctx.addParametre,
            "validation-schema": _ctx.parametreSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Clé "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "cle",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer la clé"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "cle",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Libelle "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "libelle",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le libelle"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "libelle",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_DropZone, {
                        name: "fichiers[]",
                        maxFilesize: 50,
                        maxFiles: 10,
                        uploadOnDrop: true,
                        onAddedFile: _ctx.onFileAdd,
                        onRemovedFile: _ctx.onFileRemove,
                        options: _ctx.dropzoneOptions,
                        existingFiles: _ctx.urlImage
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.hasFiles)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("img", {
                                  src: _ctx.defaultImage,
                                  alt: "Default",
                                  class: "default-image"
                                }, null, 8, _hoisted_16),
                                _cache[3] || (_cache[3] = _createElementVNode("p", null, "Glissez et dépossez ici", -1))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urlImage, (file) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: file.name,
                                    class: "dropzone-preview"
                                  }, [
                                    (file.url)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: file.url,
                                          class: "preview-image"
                                        }, null, 8, _hoisted_18))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("p", null, _toDisplayString(file.name), 1)
                                  ]))
                                }), 128))
                              ]))
                        ]),
                        _: 1
                      }, 8, ["onAddedFile", "onRemovedFile", "options", "existingFiles"])
                    ])
                  ])
                ]),
                _createElementVNode("button", _hoisted_19, _toDisplayString(_ctx.btntext), 1)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}